import styled from "styled-components";
import {Field, OptionalKeys} from "../../../Types";
import {LANG} from "../../CONSTANTS";
import FieldTypeView from "./FieldTypeView";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAtom, faEdit, faFeatherPointed, faFolderOpen} from "@fortawesome/free-solid-svg-icons";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";


type LightModeFieldViewProps = {
    field: Field,
    index: number
};

const ICONS_MAP: Partial<Record<OptionalKeys<Field>, { icon: IconDefinition, bg: string, color: string }>> = {
    inline: {
        icon: faFeatherPointed,
        bg: "#23efef",
        color: "#e512b5"
    },
    detailed: {
        icon: faFolderOpen,
        bg: "#b9c644",
        color: "#0733c3"
    },
    editable: {
        icon: faEdit,
        bg: "#00af19",
        color: "#fcfafa"
    },
    nullable: {
        icon: faAtom,
        bg: "#f10558",
        color: "#3b3838"
    },
}
export default function LightModeFieldView({field, index}: LightModeFieldViewProps) {

    return <Container>
        <div className={'txt'}>{field.key}</div>
        <div className={'txt'}>{field.title[LANG]}</div>
        <div><FieldTypeView fieldType={field.type}/></div>
        <div className="icons">
            {Object.entries(ICONS_MAP).map(([k, v]) =>
                (field as any)[k] ? <Icon className="icon" $bg={v.bg}
                                            $color={v.color} key={k}>
                    <FontAwesomeIcon size={"lg"} icon={v.icon}/>
                </Icon> : null)}
        </div>
        <div className="index">{index + 1}</div>
    </Container>
}

const Icon = styled.div<{ $color: string, $bg: string }>`

  background: ${props => props.$bg};
  padding: .2rem;
  border-radius: .2rem;

  path {
    fill: ${props => props.$color};
    stroke: ${props => props.$color};
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: .4rem;
  padding: .5rem;
  justify-content: stretch;
  align-items: center;
  height: 100%;
  //min-height: 8rem;

  position: relative;

  .icons {
    display: flex;
    flex-flow: wrap;
    gap: .5rem;

    & .icon {

    }
  }

  .index {
    position: absolute;
    bottom: .2rem;
    left: .2rem;
  }

  .txt {
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`
